module.exports = {"654003001":"团结路街道办","654003002":"乌东路街道办","654003003":"北京路街道","654003004":"乌鲁木齐西路街道","654003005":"火车站街道办","654003201":"开干齐乡","654003508":"兵团一三一团","654003510":"天北新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654003.json
// module id = 3126
// module chunks = 0